import React from "react";
import { Box, useColorModeValue } from "@chakra-ui/react";
import bg from "../assets/background.png";


const AppWrapper = ({ children }: { children: React.ReactNode }) => {
  const bgs = bg 
  return (
  <Box backgroundImage="url('/background.png')" 
  // background-position: right bottom, left top;
  backgroundPosition="inital,center"
  // background-repeat: no-repeat, repeat;
  // backgroundRepeat="no-repeat" 
  overflowY="hidden"
  minH="100vh">{children}</Box>
);

}

export default AppWrapper;
